// extracted by mini-css-extract-plugin
export default {"pageTitle":"edit-ticket-type-page_pageTitle__0FsT6","statusPanel":"edit-ticket-type-page_statusPanel__6jsFy","spinner":"edit-ticket-type-page_spinner__URT-N"};